import React from 'react';
import { useMediaQuery } from 'react-responsive';
import JobsContent from './JobsContent';

const Desktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 768 });
  return isDesktop ? children : null;
};

const DesktopResponsive = ({ history }) => (
  <Desktop>
    <JobsContent history={history} />
  </Desktop>
);

export default DesktopResponsive;
